import React, { useState } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import EnquiryModal from "../../Components/EnquiryModal";
import "../../App.css";

import anchor_rod_twin_thimble_eye from "../../Assets/anchor_rod_twin_thimble_eye.webp";
import long_shank_insulator_pin from "../../Assets/long_shank_insulator_pin.webp";
import octagonal_stay_plate from "../../Assets/octagonal_stay_plate.webp";
import earthing_hardware from "../../Assets/earthing_hardware.webp";
import adjustable_stay_rod_assembly from "../../Assets/adjustable_stay_rod_assembly.webp";

function Electric_fittings_and_components() {
  const [showEnquiry, setShowEnquiry] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const openEnquiryModal = (product) => {
    setSelectedProduct(product);
    setShowEnquiry(true);
  };

  const products = [
    {
      id: 1,
      name: "Anchor Rod - Twin Thimble Eye",
      image: anchor_rod_twin_thimble_eye,
      specs: {
        application: "Overhead Line Hardware",
        material: "Forged Steel",
        finish: "Galvanized",
        color: "Metallic Grey",
        warranty: "1 Year",
        supply: "8,000 Units / Month",
      },
    },
    {
      id: 2,
      name: "Long Shank Insulator Pin",
      image: long_shank_insulator_pin,
      specs: {
        application: "Overhead Distribution Lines",
        material: "Steel",
        finish: "Hot Dip Galvanized",
        color: "Grey",
        warranty: "1 Year",
        supply: "9,000 Units / Month",
      },
    },

    {
      id: 3,
      name: "Octagonal Stay Plate",
      image: octagonal_stay_plate,
      specs: {
        application: "Stay Rod Anchoring System",
        material: "Mild Steel",
        finish: "Hot Dip Galvanized",
        color: "Grey",
        warranty: "1 Year",
        supply: "9,000 Units / Month",
      },
    },
    {
      id: 4,
      name: "Earthing Hardware",
      image: earthing_hardware,
      specs: {
        application: "Electrical Earthing / Grounding System",
        material: "GI",
        finish: "Galvanized",
        color: "Grey",
        warranty: "1 Year",
        supply: "9,000 Units / Month",
      },
    },
    {
      id: 5,
      name: "Adjustable Stay Rod Assembly",
      image: adjustable_stay_rod_assembly,
      specs: {
        application: "Pole Stay & Guy Wire System",
        material: "Mild Steel",
        finish: "Hot Dip Galvanized",
        color: "Grey",
        warranty: "1 Year",
        supply: "9,000 Units / Month",
      },
    },
  ];

  return (
    <Container>
      <Row className="mt-5">
        {products.map((product) => (
          <Col md={6} key={product.id} className="mb-4">
            <Card className="product-card-box h-100">
              <Row className="g-0">
                <Col md={5} className="p-3 text-center">
                  <Card.Img
                    src={product.image}
                    alt={product.name}
                    style={{ maxHeight: "220px", objectFit: "contain" }}
                  />
                </Col>

                <Col md={7}>
                  <Card.Body>
                    <Card.Title className="fw-bold text-dark">
                      {product.name}
                    </Card.Title>

                    <div className="small text-muted mb-3">
                      <div>
                        <strong>Application:</strong>{" "}
                        {product.specs.application}
                      </div>
                      <div>
                        <strong>Material:</strong> {product.specs.material}
                      </div>
                      <div>
                        <strong>Finish:</strong> {product.specs.finish}
                      </div>
                      <div>
                        <strong>Color:</strong> {product.specs.color}
                      </div>
                      <div>
                        <strong>Warranty:</strong> {product.specs.warranty}
                      </div>
                      <div>
                        <strong>Supply Capacity:</strong> {product.specs.supply}
                      </div>
                    </div>

                    <button
                      className="btn btn-primary"
                      onClick={() => openEnquiryModal(product)}
                    >
                      Send Enquiry
                    </button>
                  </Card.Body>
                </Col>
              </Row>
            </Card>
          </Col>
        ))}
      </Row>

      {showEnquiry && selectedProduct && (
        <EnquiryModal
          show={showEnquiry}
          onHide={() => setShowEnquiry(false)}
          product={selectedProduct}
        />
      )}
    </Container>
  );
}

export default Electric_fittings_and_components;
